import { selectCurrentImage } from "@/reducer/designslice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Box, Image, Text, Flex, useDisclosure } from "@chakra-ui/react";
import KongImage from "@/assets/images/st_kong.gif";
import CurrentSmrContentItem from "./currentSmrContentItem";
import { Content } from "@/types/content";
import BigPictureModal from "./bigPicturemodal";
import { useState } from "react";

const SmrCenterView = () => {
  const dispatch = useAppDispatch();

  const currentImage = useAppSelector(selectCurrentImage);
  const [bigImage, setBigImage] = useState<Content>();

  const bigImageControl = useDisclosure();

  const handleBigImage = (content: Content) => {
    // dispatch(updateCurrentBigImage(content));
    setBigImage(content);
    bigImageControl.onOpen();
  };

  return (
    <Box w="100%" h="100%" position={"relative"}>
      {/* 空状态 */}
      {!currentImage.image_url && (
        <Box w="100%" h="100%" bg="#161922" borderRadius={"10px"}>
          <Flex
            sx={{
              width: "full",
              height: "full",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <Box color="#5B5F6D" textAlign={"center"} fontSize="18px">
              <Image w="180px" h="198px" src={KongImage} />
              <Text>等你好久了</Text>
              <Text>快去上传您的毛坯房照片吧~</Text>
            </Box>
          </Flex>
        </Box>
      )}
      {/* 出图了 */}
      {currentImage.image_url && (
        <Box w="100%" h="100%" position={"relative"}>
          <Box h={"100%"} position="relative">
            <CurrentSmrContentItem
              content={currentImage}
              handleBigImage={handleBigImage}
            />
          </Box>

          {/* <SimpleGrid
            w="100%"
            height={"100%"}
            columns={currentImage.length > 1 ? 2 : 1}
            spacing={"20px"}
          >
            {currentImage &&
              currentImage.length > 0 &&
              currentImage.map((item) => (
                <Box
                  key={item.id}
                  h={currentImage.length > 1 ? "calc(50% - 10px)" : "100%"}
                  position="relative"
                >
                  <CurrentSmrContentItem
                    content={item}
                    handleBigImage={handleBigImage}
                  />
                </Box>
              ))}
          </SimpleGrid> */}
        </Box>
      )}
      {bigImage && (
        <BigPictureModal
          isOpen={bigImageControl.isOpen}
          onClose={bigImageControl.onClose}
          bigImage={bigImage}
        />
      )}
    </Box>
  );
};

export default SmrCenterView;
